import React from 'react'

export default function MemberThemeProvider({ branding, children }) {
  const style = {
    '--color-primary': branding?.primary ?? 'var(--mp-accent)',
    '--color-primary-soft': branding?.primarySoft ?? 'var(--mp-accent-soft)',
    '--color-accent': branding?.accent ?? 'var(--mp-accent)',
    '--color-bg': branding?.background ?? 'var(--mp-bg)',
    '--color-surface': branding?.surface ?? 'var(--mp-surface)',
    '--color-card-bg': branding?.cardBg ?? 'var(--mp-card)',
    '--color-text': branding?.textPrimary ?? 'var(--mp-text)',
    '--color-muted': branding?.textMuted ?? 'var(--mp-muted)',
  }

  return (
    <div className="member-portal-root" style={style}>
      {children}
    </div>
  )
}
